import React from 'react'
import {Flex, Text} from '../../../../vanilla'
import {Link} from '../../../link'
import {ChevronRightIcon} from '../../../icons'
import {observer} from 'mobx-react'
import {useCustomerStore} from '../../../../store/hooks/useStore'
import { MobileNavigationLoggedLinksProps } from '../mobile-navigation-logged-links'

const DeliveryInitial = observer(({onClose}: MobileNavigationLoggedLinksProps) => {
  const {isRegistered} = useCustomerStore()

  return (
    <Flex
      as={Link}
      to="/select-delivery"
      onClick={onClose}
      justify="space-between"
      align="center"
      width="full"
      data-test-selector="same-day-delivery-link"
    >
      <Text variant="text2Bold" lineHeight="short">
        {isRegistered ? 'Same Day Delivery' : 'Same Day Delivery & FREE Next Day Delivery'}
      </Text>
      <ChevronRightIcon width="16px" height="auto" color="gray800" flexShrink="0" />
    </Flex>
  )
})

export default DeliveryInitial
